import { IntentAction } from './types'
import { Persona } from '@/ux/types'

export function executeAction(
  action: IntentAction,
  context: {
    setPersona: (p: Persona) => void
    navigate: (path: string) => void
  }
) {
  switch (action.type) {
    case 'setPersona':
      context.setPersona(action.value)
      break

    case 'navigate':
      context.navigate(action.path)
      // Scroll to top after navigation
      setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100)
      break

    case 'scrollTo':
      setTimeout(() => {
        const element = document.querySelector(action.selector)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      }, 300)
      break

    case 'highlight':
      {
        const element = document.querySelector(action.selector)
        if (element) {
          element.classList.add('highlight-pulse')
          setTimeout(() => {
            element.classList.remove('highlight-pulse')
          }, action.duration || 2000)
        }
      }
      break

    case 'composite':
      action.actions.forEach((subAction, index) => {
        setTimeout(() => executeAction(subAction, context), index * 200)
      })
      break
  }
}
